import React, { useState } from 'react';
import { Button, Paper, styled, TableBody, TableContainer, TableHead, Dialog, DialogTitle, Table, TablePagination, ToggleButton } from '@mui/material'
import { Col, Form, InputGroup, Row } from 'react-bootstrap';
import Home from '../home/Home';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import SearchIcon from '@mui/icons-material/Search';
import { Container } from '@mui/system';
import BillingService from '../../Services/MasterBilling/BillingService';
import { getDate, getUserId } from '../Utils/Common';
import { useEffect } from 'react';
import Snacbar from '../Snacbar';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useNavigate } from "react-router";

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(0.5),
  // textAlign: 'center',
  color: theme.palette.text.secondary,
  backgroundColor: 'white',
  height: '100%',
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    color: theme.palette.common.black,
    backgroundColor: 'rgb(61, 195, 177)',
    padding: theme.spacing(0.5),
    fontFamily: 'Times New Roman',
    fontWeight: 'bold',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: 'Times New Roman',
    textAlign: 'center'
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: 'white',
  },
}));

function QuotationImporter() {
  const [DrpQuatetionTyp, setDrpQuatetionTyp] = useState([]);
  const [tDrpItem, setDrpItem] = useState([]);
  const [CustomerType, setCustomerType] = useState([]);
  const [CustomerBasedCustomerType, setCustomerBasedCustomerType] = useState([]);
  const [CustomLocation, setCustomLocation] = useState([]);
  const [UOM, setUOM] = useState([]);
  const [Charge, setCharge] = useState([]);
  const [CustomTariff, setCustomTariff] = useState([]);
  const [filterdetails, setfilterdetails] = useState([]);

  const [open, setOpen] = useState(false);
  const [severity, setSeverity] = useState('');
  const [message, setMessage] = useState('');

  const [DialogImporter, setDialogImporter] = useState([]);
  const [DialogCustomHouseCode, setDialogCustomHouseCode] = useState([]);
  const [DialogUOMSearch, setDialogUOMSearch] = useState([]);

  const [QuotImp_values, setQuotImp_values] = useState({
    quotationtype: 'General', servicetype: 'IMPORT', itemdescription: 'General Goods', customertype: 'Importer', basedonQuot: 'YES', tarifstart_date: getDate(), tarifend_date: getDate(),
    disable_transistmode: '', importername: '', transitTypeCode: '', amountPerMaxUnit: '', flatRatePerMaxUnit: '', customTariffID: '', customerId: '',
    disable_importerIecCode: '', edilocation: '', disable_edilocation: '', unit: '', disable_unit: '', maxCharge: '', chargename: '', minCharge: '', AssessableValueBasedChrg: '',
    // dialog inputClasses....
    findimportername: '', findimportercode: '', findCusHousename: '', findCusHousecode: '', findUnitname: '', findUnitcode: ''
  })
  const [error, setError] = useState({
    DrpQuatetionTyp: false, servicetype: false, customerType: false, basedonQuotetion: false, tariffStartDate: false, tarifend_date: false, importerName: false, ediLocation: false,
    unit: false, ChargeName: false, minimumChargeInR: false, transitTypeCode: false
  });

  const [savedsa, setSavedsa] = useState(false);
  const [Updatedsa, setUpdatedsa] = useState(true);
  const [Deletedsa, setDeletedsa] = useState(true);
  const [QutetionSve, setQutetionsave] = useState(false);
  const [QutetionUpd, setQutetionUpd] = useState(false);
  const [QutetionDlt, setQutetionDlt] = useState(false);

  const [searchdsa, setsearchdsa] = useState(false);
  const [Verifydsa, setVerifydsa] = useState(false);
  const [UnVerifydsa, setUnVerifydsa] = useState(false);
  const [QutetionSearch, setQutetionSearch] = useState(false);
  const [QutetionVerify, setQutetionVerify] = useState(false);
  const [QutetionUnVerify, setQutetionUnVerify] = useState(false);


  // onchangechange...//.
  const QuotImp_quotationtypehandlechange = (e) => {
    setQuotImp_values({ ...QuotImp_values, quotationtype: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  }
  const QuotImp_servicetypehandlechange = (e) => {
    setQuotImp_values({ ...QuotImp_values, servicetype: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  }
  const QuotImp_itemdescriptionhandlechange = (e) => {
    setQuotImp_values({ ...QuotImp_values, itemdescription: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  }
  const QuotImp_customertypehandlechange = (e) => {
    setQuotImp_values({ ...QuotImp_values, customertype: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  }
  const QuotImp_basedonQuothandlechange = (e) => {
    setQuotImp_values({ ...QuotImp_values, basedonQuot: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  }
  const QuotImp_tarifstart_datehandlechange = (e) => {
    setQuotImp_values({ ...QuotImp_values, tarifstart_date: e.target.value })
  }
  const QuotImp_tarifend_datehandlechange = (e) => {
    setQuotImp_values({ ...QuotImp_values, tarifend_date: e.target.value })
  }
  const QuotImp_disable_transistmodehandlechange = (e) => {
    setQuotImp_values({ ...QuotImp_values, disable_transistmode: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  }
  const QuotImp_importernamehandlechange = (e) => {
    const filterDetails = CustomerBasedCustomerType.find((node) => node.importer_name === e.target.value)
    setQuotImp_values({ ...QuotImp_values, importername: e.target.value, disable_importerIecCode: filterDetails.importer_iec_no })
  }

  const QuotImp_edilocationhandlechange = (e) => {
    const filteValue = CustomLocation.find((node) => node.clearanceLocationName === e.target.value)
    setQuotImp_values({ ...QuotImp_values, edilocation: e.target.value, disable_edilocation: filteValue.clearanceLocationCode, disable_transistmode: filteValue.transitTypeName, transitTypeCode: filteValue.transitTypeCode });
  }

  const QuotImp_unithandlechange = (e) => {
    const filteValue = UOM.find((node) => node.unitName === e.target.value)
    setQuotImp_values({ ...QuotImp_values, unit: e.target.value, disable_unit: filteValue.unitCode })
  }

  const QuotImp_maxChargehandlechange = (e) => {
    setQuotImp_values({ ...QuotImp_values, maxCharge: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  }
  const QuotImp_chargenamehandlechange = (e) => {
    setQuotImp_values({ ...QuotImp_values, chargename: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  }
  const QuotImp_minChargehandlechange = (e) => {
    setQuotImp_values({ ...QuotImp_values, minCharge: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  }
  const QuotImp_AssessableValueBasedChrghandlechange = (e) => {
    setQuotImp_values({ ...QuotImp_values, AssessableValueBasedChrg: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  }
  const QuotImp_findimporternamehandlechange = (e) => {
    setQuotImp_values({ ...QuotImp_values, findimportername: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') });
    var importerName = '';
    if (e.target.value !== '') {
      importerName = e.target.value;
    } else {
      importerName = '-1'
    }
    let details = { importerName: importerName, importerIecNo: '-1', flag: 2 }
    BillingService.getImporter(details).then((res) => { setDialogImporter(res.data); });
  }
  const QuotImp_findimportercodehandlechange = (e) => {
    setQuotImp_values({ ...QuotImp_values, findimportercode: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') });
    var importerIecNo = '';
    if (e.target.value !== '') {
      importerIecNo = e.target.value;
    } else {
      importerIecNo = '-1'
    }
    let details = { importerName: '-1', importerIecNo: importerIecNo, flag: 2 }
    BillingService.getImporter(details).then((res) => { setDialogImporter(res.data); });
  }
  const QuotImp_findCusHousenamehandlechange = (e) => {
    setQuotImp_values({ ...QuotImp_values, findCusHousename: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') });
    var clearanceLocationName = '';
    if (e.target.value !== '') {
      clearanceLocationName = e.target.value;
    } else {
      clearanceLocationName = '-1'
    }
    let details = { clearanceLocationName: clearanceLocationName, clearanceLocationCode: '-1', flag: 2 }
    BillingService.getCustomHouseCode(details).then((res) => { setDialogCustomHouseCode(res.data); })
  }
  const QuotImp_findCusHousecodehandlechange = (e) => {
    setQuotImp_values({ ...QuotImp_values, findCusHousecode: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    var clearanceLocationCode = '';
    if (e.target.value !== '') {
      clearanceLocationCode = e.target.value;
    } else {
      clearanceLocationCode = '-1'
    }
    let details = { clearanceLocationName: '-1', clearanceLocationCode: clearanceLocationCode, flag: 2 }
    BillingService.getCustomHouseCode(details).then((res) => { setDialogCustomHouseCode(res.data); })
  }
  const QuotImp_findUnitnamehandlechange = (e) => {
    setQuotImp_values({ ...QuotImp_values, findUnitname: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') });
    var unitName = '';
    if (e.target.value !== '') {
      unitName = e.target.value;
    } else {
      unitName = '-1'
    }
    let details = { unitName: unitName, unitCode: '-1', flag: 2 }
    BillingService.getUOMSearch(details).then((res) => { setDialogUOMSearch(res.data); })
  }
  const QuotImp_findUnitcodehandlechange = (e) => {
    setQuotImp_values({ ...QuotImp_values, findUnitcode: e.target.value });
    var unitCode = '';
    if (e.target.value !== '') {
      unitCode = e.target.value;
    } else {
      unitCode = '-1'
    }
    let details = { unitName: '-1', unitCode: unitCode, flag: 2 }
    BillingService.getUOMSearch(details).then((res) => { setDialogUOMSearch(res.data); })
  }

  ////dialogboxes open close ========>

  const [ImporterDetailshandleopen, setImporterDetailshandleopen] = useState(false);
  const [CustomHouseDetailshandleopen, setCustomHouseDetailshandleopen] = useState(false);
  const [UnitCodeDetailshandleCopen, setUnitCodeDetailshandleCopen] = useState(false);

  //keydown
  const QuotImp_findimporternameKeyDown = (e) => {
    if (e.key === 'Enter') {
      document.getElementById('dialogImportIecCode').focus();
    }
  }

  const ImporterDetailshandleClickClose = (e) => {
    setQuotImp_values({ ...QuotImp_values, findimportername: '', findimportercode: '' })
    setImporterDetailshandleopen(false)
  }
  const ImporterDetailshandleClickopen = (e) => {
    setQuotImp_values({ ...QuotImp_values, findimportername: QuotImp_values.importername, findimportercode: QuotImp_values.disable_importerIecCode })
    setImporterDetailshandleopen(true)
    var importerName, importerIecNo = '';
    if (QuotImp_values.importername !== '') {
      importerName = QuotImp_values.importername;
    } else {
      importerName = '-1';
    }
    if (QuotImp_values.disable_importerIecCode !== '') {
      importerIecNo = QuotImp_values.disable_importerIecCode;
    } else {
      importerIecNo = '-1';
    }
    let details = { importerName: importerName, importerIecNo: importerIecNo, flag: 2 }
    BillingService.getImporter(details).then((res) => { setDialogImporter(res.data); })
  }

  const CustomHouseDetailshandleClickClose = (e) => {
    setCustomHouseDetailshandleopen(false);
    setQuotImp_values({ ...QuotImp_values, findCusHousecode: '', findCusHousename: '' });
  }
  const CustomHouseDetailshandleClickopen = (e) => {
    setQuotImp_values({ ...QuotImp_values, findCusHousecode: QuotImp_values.edilocation, findCusHousename: QuotImp_values.disable_edilocation });
    setCustomHouseDetailshandleopen(true)
    var clearanceLocationName, clearanceLocationCode = '';
    if (QuotImp_values.edilocation !== '') {
      clearanceLocationName = QuotImp_values.edilocation;
    } else {
      clearanceLocationName = '-1'
    }
    if (QuotImp_values.disable_edilocation !== '') {
      clearanceLocationCode = QuotImp_values.disable_edilocation;
    } else {
      clearanceLocationCode = '-1'
    }
    let details = { clearanceLocationName: clearanceLocationName, clearanceLocationCode: clearanceLocationCode, flag: 2 }
    BillingService.getCustomHouseCode(details).then((res) => { setDialogCustomHouseCode(res.data); })
  }

  const UnitCodeDetailshandleClickClose = (e) => {
    setUnitCodeDetailshandleCopen(false)
  }
  const UnitCodeDetailshandleClickopen = (e) => {
    setQuotImp_values({ ...QuotImp_values, findUnitcode: QuotImp_values.disable_unit, findUnitname: QuotImp_values.unit });
    setUnitCodeDetailshandleCopen(true);
    var unitName, unitCode = '';
    if (QuotImp_values.unit !== '') {
      unitName = QuotImp_values.unit;
    } else {
      unitName = '-1'
    }
    if (QuotImp_values.disable_unit !== '') {
      unitCode = QuotImp_values.disable_unit;
    } else {
      unitCode = '-1'
    }
    let details = { unitName: unitName, unitCode: unitCode, flag: 2 }
    BillingService.getUOMSearch(details).then((res) => { setDialogUOMSearch(res.data); })
  }


  //DialogTbleClick
  const EditImporterDetails = (item) => {
    setImporterDetailshandleopen(false);
    setQuotImp_values({ ...QuotImp_values, importername: item.importerName, disable_importerIecCode: item.importerIecNo, findimportername: '', findimportercode: '' });
  }

  const EditCustomHouseCode = (item) => {
    setCustomHouseDetailshandleopen(false);
    setQuotImp_values({
      ...QuotImp_values, edilocation: item.clearanceLocationName, disable_edilocation: item.clearanceLocationCode, disable_transistmode: item.transitTypeName, transitTypeCode: item.transitTypeCode,
      findCusHousecode: '', findCusHousename: ''
    });
  }

  const EditUnitcodeaasign = (item) => {
    setUnitCodeDetailshandleCopen(false);
    setQuotImp_values({ ...QuotImp_values, unit: item.unitName, disable_unit: item.unitCode, findUnitname: '', findUnitcode: '' })

  }

  //getDatas
  const getDrp = () => {
    BillingService.getQuotationType().then((res) => {
      setDrpQuatetionTyp(res.data);
    });
    BillingService.getItem().then((res) => {
      setDrpItem(res.data);
    });
    BillingService.getCustomerType(1).then((res) => {
      setCustomerType(res.data);
    });
    BillingService.getCustomerBasedCustomerType('Importer').then((res) => {
      setCustomerBasedCustomerType(res.data);
    });
    BillingService.getCustomLocation().then((res) => {
      setCustomLocation(res.data);
    });
    BillingService.getUOM().then((res) => {
      setUOM(res.data);
    });
    BillingService.getCharge().then((res) => {
      setCharge(res.data);
    });
  }

  const getData = async () => {
    BillingService.getCustomTariffALL().then((res) => {
      setCustomTariff(res.data);
      setfilterdetails(res.data)
    })
  }

  const getTariffSearch = () => {
    setsearchdsa(true);
    setQutetionSearch(true);
    var importerIecNo, clearanceLocationCode, unitCode = '';
    if (QuotImp_values.disable_importerIecCode !== '') {
      importerIecNo = QuotImp_values.disable_importerIecCode;
    } else {
      importerIecNo = '-1'
    }
    if (QuotImp_values.edilocation !== '') {
      clearanceLocationCode = QuotImp_values.disable_edilocation;
    } else {
      clearanceLocationCode = '-1'
    }
    if (QuotImp_values.unit !== '') {
      unitCode = QuotImp_values.disable_unit;
    } else {
      unitCode = '-1';
    }
    let detailsImp = { importerIecNo: importerIecNo, clearanceLocationCode: clearanceLocationCode, unitCode: unitCode }
    BillingService.getCustomTariff(detailsImp).then((res) => {
      setCustomTariff(res.data); setfilterdetails(res.data)

      console.log('customtarif==' + JSON.stringify(res.data))
    });
    setsearchdsa(false); setQutetionSearch(false);
  }

  useEffect(() => {
    const getData = async () => {
      BillingService.getCustomTariffALL().then((res) => {
        setCustomTariff(res.data);
        setfilterdetails(res.data)
      })
    }
    getData();
    getDrp();
  }, []);


  //tableClick
  const EditQuatetionImpDetails = (item) => {
    setError({
      ...error, DrpQuatetionTyp: false, servicetype: false, customerType: false, basedonQuotetion: false, tariffStartDate: false, tarifend_date: false, importerName: false, ediLocation: false,
      unit: false, ChargeName: false, minimumChargeInR: false, transitTypeCode: false
    });
    setSavedsa(true); setUpdatedsa(false); setDeletedsa(false); setsearchdsa(false); setVerifydsa(false); setUnVerifydsa(false);
    setQutetionsave(false); setQutetionUpd(false); setQutetionDlt(false); setQutetionSearch(false); setQutetionVerify(false); setQutetionUnVerify(false);
    setQuotImp_values({
      ...QuotImp_values, quotationtype: item.quotationType, servicetype: item.serviceType, itemdescription: item.itemTypeName, customertype: item.customerType,
      basedonQuot: item.basedOnQuotation, customTariffID: item.customTariffID, customerId: item.customerId,
      tarifstart_date: item.tariffStartDate, tarifend_date: item.tariffEndDate, disable_transistmode: item.transitTypeName, transitTypeCode: item.transitTypeCode, importername: item.importerName,
      disable_importerIecCode: item.iecNo, edilocation: item.gatewayPortName, disable_edilocation: item.gatewayPortCode, unit: item.unitName, disable_unit: item.unitCode, maxCharge: item.amtPerUnit,
      chargename: item.chargeName, minCharge: item.minimumCharge, AssessableValueBasedChrg: item.maximumUnit, flatRatePerMaxUnit: item.flatRatePerMaxUnit, amountPerMaxUnit: item.amountPerMaxUnit
    });
  }

  //clickEventes

  const validate = () => {
    if (QuotImp_values.quotationtype !== '') {
      if (QuotImp_values.customertype !== '') {
        if (QuotImp_values.disable_importerIecCode !== '') {
          if (QuotImp_values.disable_transistmode !== '') {
            if (QuotImp_values.edilocation !== '') {
              if (QuotImp_values.disable_unit !== '') {
                if (QuotImp_values.chargename !== '') {
                  if (QuotImp_values.basedonQuot !== '') {
                    if (QuotImp_values.minCharge !== '') {
                      if (QuotImp_values.servicetype !== '') {
                        return true;
                      }
                      else {
                        setError({ ...error, servicetype: true });
                        document.getElementById('serviceType').focus();
                        setOpen(true); setSeverity('warning'); setMessage('Please select the service Type ..!!');
                        setQutetionsave(false)
                      }
                    }

                    else {
                      setError({ ...error, minimumChargeInR: true });
                      document.getElementById('minimumChargeINR').focus();
                      setOpen(true); setSeverity('warning'); setMessage('Please Enter Minimum Charge ..!!');
                      setQutetionsave(false)
                    }
                  }

                  else {
                    setError({ ...error, basedonQuotetion: true });
                    document.getElementById('BasedOnQuotation').focus();
                    setOpen(true); setSeverity('warning'); setMessage('Please Select Based On Quotation ..!!');
                    setQutetionsave(false)
                  }
                }
                else {
                  setError({ ...error, ChargeName: true });
                  document.getElementById('chargename').focus();
                  setOpen(true); setSeverity('warning'); setMessage('Please Select Charge Name ..!!');
                  setQutetionsave(false)
                }
              }
              else {
                setError({ ...error, unit: true });
                document.getElementById('Unit').focus();
                setOpen(true); setSeverity('warning'); setMessage('Please Select UOM ..!!');
                setQutetionsave(false)
              }
            }
            else {
              setError({ ...error, ediLocation: true });
              document.getElementById('EdiLocation').focus();
              setOpen(true); setSeverity('warning'); setMessage('Please Select Gateway Port ..!!');
              setQutetionsave(false)
            }
          }
          else {
            setError({ ...error, transitTypeCode: true });
            document.getElementById('transitmode').focus();
            setOpen(true); setSeverity('warning'); setMessage('Please Select Transit Mode ..!!');
            setQutetionsave(false)
          }
        }
        else {
          setError({ ...error, importerName: true });
          document.getElementById('ImporterName').focus();
          setOpen(true); setSeverity('warning'); setMessage('Please Select IEC NO ..!!');
          setQutetionsave(false)
        }
      }
      else {
        setError({ ...error, customerType: true });
        document.getElementById('customertype').focus();
        setOpen(true); setSeverity('warning'); setMessage('Please Select Customer Type ..!!');
        setQutetionsave(false)
      }
    }
    else {
      setError({ ...error, DrpQuatetionTyp: true });
      document.getElementById('DrpQuatetionTyp').focus();
      setOpen(true); setSeverity('warning'); setMessage('Please Select Quotation Type ..!!');
      setQutetionsave(false)
    }
    return false;
  }

  const QuatetionSave = () => {
    setQutetionsave(true)
    if (validate() === true) {
      setSavedsa(true);
      var minimumCharge, amtPerUnit, itemIDString, maximumUnit, amountPerMaxUnit, flatRatePerMaxUnit = '';
      if (QuotImp_values.minCharge === '' || !QuotImp_values.minCharge) {
        minimumCharge = null
      } else {
        minimumCharge = QuotImp_values.minCharge;
      } if (QuotImp_values.maxCharge === '' || !QuotImp_values.maxCharge) {
        amtPerUnit = null;
      } else {
        amtPerUnit = QuotImp_values.maxCharge;
      } if (QuotImp_values.itemdescription === '' || !QuotImp_values.itemdescription) {
        itemIDString = null;
      } else {
        itemIDString = QuotImp_values.itemdescription;
      } if (QuotImp_values.AssessableValueBasedChrg === '' || !QuotImp_values.AssessableValueBasedChrg) {
        maximumUnit = null;
      } else {
        maximumUnit = QuotImp_values.AssessableValueBasedChrg;
      } if (QuotImp_values.amountPerMaxUnit === '' || !QuotImp_values.amountPerMaxUnit) {
        amountPerMaxUnit = null;
      } else {
        amountPerMaxUnit = QuotImp_values.amountPerMaxUnit;
      } if (QuotImp_values.flatRatePerMaxUnit === '' || QuotImp_values.flatRatePerMaxUnit) {
        flatRatePerMaxUnit = null;
      } else {
        flatRatePerMaxUnit = QuotImp_values.flatRatePerMaxUnit;
      }
      let details = {
        iecNo: QuotImp_values.disable_importerIecCode, tariffStartDate: QuotImp_values.tarifstart_date, tariffEndDate: QuotImp_values.tarifend_date, transitTypeCode: QuotImp_values.transitTypeCode,
        gatewayPortCode: QuotImp_values.disable_edilocation, chargeName: QuotImp_values.chargename, unitName: QuotImp_values.disable_unit, minimumCharge: minimumCharge, amtPerUnit: amtPerUnit, basedOnQuotation: QuotImp_values.basedonQuot,
        serviceType: QuotImp_values.servicetype, itemIDString: itemIDString, createdBy: getUserId(), customerId: 1, quotationType: QuotImp_values.quotationtype, maximumUnit: maximumUnit, amountPerMaxUnit: amountPerMaxUnit,
        flatRatePerMaxUnit: flatRatePerMaxUnit
      }
      BillingService.insertCustomTariff(details).then((res) => {
        const message = res.data.message;
        if (message.toString() === 'SUCCESS') {
          setOpen(true); setSeverity('success'); setMessage('Insert Successfully');
        } else {
          setOpen(true); setSeverity('error'); setMessage('Insertion Failed' + message);
        }
        let detailsImp = { importerIecNo: QuotImp_values.disable_importerIecCode, clearanceLocationCode: QuotImp_values.edilocation, unitCode: QuotImp_values.unit }
        BillingService.getCustomTariff(detailsImp).then((res) => {
          setCustomTariff(res.data);
          setfilterdetails(res.data)
        });
        setSavedsa(false); setUpdatedsa(true); setDeletedsa(true); setsearchdsa(false); setVerifydsa(false); setUnVerifydsa(false);
        setQutetionsave(false); setQutetionUpd(false); setQutetionDlt(false); setQutetionSearch(false); setQutetionVerify(false); setQutetionUnVerify(false);
        // refresh();
        setSavedsa(false); setUpdatedsa(true); setDeletedsa(true); setsearchdsa(false); setVerifydsa(false); setUnVerifydsa(false);
        setQutetionUpd(false); setQutetionDlt(false); setQutetionSearch(false); setQutetionVerify(false); setQutetionUnVerify(false);
        getData();
      }).catch(error => {
        setOpen(true); setSeverity('error'); setMessage(error.message); refresh();
        setQutetionsave(false)
      })
    }
  }
  const QuatetionUpdate = () => {
    if (validate() === true) {
      if (QuotImp_values.customTariffID !== '') {
        setUpdatedsa(true); setQutetionUpd(true);
        var minimumCharge, amtPerUnit, itemIDString, maximumUnit, amountPerMaxUnit, flatRatePerMaxUnit = '';
        if (QuotImp_values.minCharge === '' || !QuotImp_values.minCharge) {
          minimumCharge = null
        } else {
          minimumCharge = QuotImp_values.minCharge;
        } if (QuotImp_values.maxCharge === '' || !QuotImp_values.maxCharge) {
          amtPerUnit = null;
        } else {
          amtPerUnit = QuotImp_values.maxCharge;
        } if (QuotImp_values.itemdescription === '' || !QuotImp_values.itemdescription) {
          itemIDString = null;
        } else {
          itemIDString = QuotImp_values.itemdescription;
        } if (QuotImp_values.AssessableValueBasedChrg === '' || !QuotImp_values.AssessableValueBasedChrg) {
          maximumUnit = null;
        } else {
          maximumUnit = QuotImp_values.AssessableValueBasedChrg;
        } if (QuotImp_values.amountPerMaxUnit === '' || !QuotImp_values.amountPerMaxUnit) {
          amountPerMaxUnit = null;
        } else {
          amountPerMaxUnit = QuotImp_values.amountPerMaxUnit;
        } if (QuotImp_values.flatRatePerMaxUnit === '' || QuotImp_values.flatRatePerMaxUnit) {
          flatRatePerMaxUnit = null;
        } else {
          flatRatePerMaxUnit = QuotImp_values.flatRatePerMaxUnit;
        }
        let details = {
          customTariffID: QuotImp_values.customTariffID, iecNo: QuotImp_values.disable_importerIecCode, tariffStartDate: QuotImp_values.tarifstart_date, tariffEndDate: QuotImp_values.tarifend_date, transitTypeCode: QuotImp_values.transitTypeCode,
          gatewayPortCode: QuotImp_values.disable_edilocation, chargeName: QuotImp_values.chargename, unitName: QuotImp_values.disable_unit, minimumCharge: minimumCharge, amtPerUnit: amtPerUnit, basedOnQuotation: QuotImp_values.basedonQuot,
          serviceType: QuotImp_values.servicetype, itemIDString: itemIDString, createdBy: getUserId(), customerId: QuotImp_values.customerId, quotationType: QuotImp_values.quotationtype, maximumUnit: maximumUnit, amountPerMaxUnit: amountPerMaxUnit,
          flatRatePerMaxUnit: flatRatePerMaxUnit
        }
        BillingService.updateCustomTariff(details).then((res) => {
          const message = res.data.message;
          if (message.toString() === 'SUCCESS') {
            setOpen(true); setSeverity('success'); setMessage('Update Successfully');
          } else {
            setOpen(true); setSeverity('error'); setMessage('Update Failed' + message);
          }
          refresh();
        }).catch(error => {
          setOpen(true); setSeverity('error'); setMessage(error.message); refresh();
        })
      } else {
        setOpen(true); setSeverity('warning'); setMessage('Please Select Custom Tariff From the List ..!');
      }
    }
  }

  const QuotationDelete = () => {
    if (QuotImp_values.customTariffID !== '') {
      setDeletedsa(true); setQutetionDlt(true);
      BillingService.deleteCustomTariff(QuotImp_values.customTariffID).then((res) => {
        const message = res.data.message;
        if (message.toString() === 'SUCCESS') {
          setOpen(true); setSeverity('success'); setMessage('Delete Successfully');
        } else {
          setOpen(true); setSeverity('error'); setMessage('Delete Failed' + message);
        }
        refresh();
      }).catch(error => {
        setOpen(true); setSeverity('error'); setMessage(error.message); refresh();
      })
    } else {
      setOpen(true); setSeverity('warning'); setMessage('Please Select Custom Tariff From the List ..!');
    }
  }

  const verified = () => {
    if (QuotImp_values.customTariffID !== '') {
      setVerifydsa(true); setQutetionVerify(true);
      let details = { customTariffID: QuotImp_values.customTariffID, verifiedStatus: 'Y', flag: 1 }
      BillingService.updateCustomTariffVerifiedStatus(details).then((res) => {
        const message = res.data.message;
        if (message.toString() === 'SUCCESS') {
          setOpen(true); setSeverity('success'); setMessage('Verified Successfully');
        } else {
          setOpen(true); setSeverity('error'); setMessage('Verified Failed' + message);
        }
        refresh();
      }).catch(error => {
        setOpen(true); setSeverity('error'); setMessage(error.message); refresh();
      });
    } else {
      setOpen(true); setSeverity('warning'); setMessage('Kindly select the Datagrid ..!');
    }
  }
  const UnVerified = () => {
    if (QuotImp_values.customTariffID !== '') {
      setUnVerifydsa(true); setQutetionUnVerify(true);
      let details = { customTariffID: QuotImp_values.customTariffID, verifiedStatus: 'N', flag: 1 }
      BillingService.updateCustomTariffVerifiedStatus(details).then((res) => {
        const message = res.data.message;
        if (message.toString() === 'SUCCESS') {
          setOpen(true); setSeverity('success'); setMessage('Unverified Successfully');
        } else {
          setOpen(true); setSeverity('error'); setMessage('Unverified Failed' + message);
        }
        refresh();
      }).catch(error => {
        setOpen(true); setSeverity('error'); setMessage(error.message); refresh();
      });
    } else {
      setOpen(true); setSeverity('warning'); setMessage('Kindly select the Datagrid ..!');
    }
  }

  const refresh = () => {
    setError({
      ...error, DrpQuatetionTyp: false, servicetype: false, customerType: false, basedonQuotetion: false, tariffStartDate: false, tarifend_date: false, importerName: false, ediLocation: false,
      unit: false, ChargeName: false, minimumChargeInR: false, transitTypeCode: false
    });
    setSavedsa(false); setUpdatedsa(true); setDeletedsa(true); setsearchdsa(false); setVerifydsa(false); setUnVerifydsa(false);
    setQutetionsave(false); setQutetionUpd(false); setQutetionDlt(false); setQutetionSearch(false); setQutetionVerify(false); setQutetionUnVerify(false);
    setQuotImp_values({
      ...QuotImp_values, quotationtype: 'General', servicetype: 'IMPORT', itemdescription: 'General Goods', customertype: 'Importer', basedonQuot: 'YES', tarifstart_date: getDate(), tarifend_date: getDate(),
      disable_transistmode: '', importername: '', transitTypeCode: '', amountPerMaxUnit: '', flatRatePerMaxUnit: '', customTariffID: '', customerId: '',
      disable_importerIecCode: '', edilocation: '', disable_edilocation: '', unit: '', disable_unit: '', maxCharge: '', chargename: '', minCharge: '', AssessableValueBasedChrg: '',
      // dialog inputClasses....
      findimportername: '', findimportercode: '', findCusHousename: '', findCusHousecode: '', findUnitname: '', findUnitcode: ''
    });
    getData();
  }

  //handleClose/open
  const handleClose = () => {
    setOpen(false);
  }
  //Tablesearch
  const importerNameSrch = () => {
    return <input style={{ width: '80%', fontSize: '10px' }} className='searchBox' onChange={(e) => { importerNmOnchange(e.target.value) }} />
  }

  const importerNmOnchange = (serachedval) => {

    const filteredvalue = CustomTariff.filter((trns) => {
      return trns.importerName.toString().toLowerCase().includes(serachedval.toLowerCase())
    })
    if (serachedval.length < 1) {
      setfilterdetails(CustomTariff)
    } else {
      setfilterdetails(filteredvalue)
      // console.log("filtervalues===>"+JSON.stringify(CustomTariff))
    }
  }

  const modeSrch = () => {
    return <input className='searchBox' style={{ width: '40px' }} onChange={(e) => { modeOnchange(e.target.value) }} />
  }

  const modeOnchange = (serachedval) => {

    const filteredvalue = CustomTariff.filter((trns) => {
      return trns.transitTypeName.toString().toLowerCase().includes(serachedval.toLowerCase())
    })
    if (serachedval.length < 1) {
      setfilterdetails(CustomTariff)
    } else {
      setfilterdetails(filteredvalue)
      // console.log("filtervalues===>"+JSON.stringify(CustomTariff))
    }
  }
  const gatewayportSrch = () => {
    return <input className='searchBox' style={{ width: '100px' }} onChange={(e) => { gatewayportOnchange(e.target.value) }} />
  }

  const gatewayportOnchange = (serachedval) => {

    const filteredvalue = CustomTariff.filter((trns) => {
      return trns.gatewayPortName.toString().toLowerCase().includes(serachedval.toLowerCase())
    })
    if (serachedval.length < 1) {
      setfilterdetails(CustomTariff)
    } else {
      setfilterdetails(filteredvalue)
      // console.log("filtervalues===>"+JSON.stringify(CustomTariff))
    }
  }
  const chargeNameSrch = () => {
    return <input className='searchBox' style={{ width: '100px' }} onChange={(e) => { chargeNameOnchange(e.target.value) }} />
  }

  const chargeNameOnchange = (serachedval) => {

    const filteredvalue = CustomTariff.filter((trns) => {
      return trns.chargeName.toString().toLowerCase().includes(serachedval.toLowerCase())
    })
    if (serachedval.length < 1) {
      setfilterdetails(CustomTariff)
    } else {
      setfilterdetails(filteredvalue)
      // console.log("filtervalues===>"+JSON.stringify(CustomTariff))
    }
  }
  //paginationCodes

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }
  const navigate = useNavigate();
  const BackBotton = () => {
    navigate('/Billcharge');
  }
  const ForwordBotton = () => {
    navigate('/qutationForwarder');
  }
  return (
    <div>
      <div>
        <Dialog open={ImporterDetailshandleopen} onClose={ImporterDetailshandleClickClose} fullWidth={true} maxWidth='md' >
          <DialogTitle align='center' className="p-1 bg-info" style={{ fontFamily: 'Times New Roman'}}>
            VIEW IMPORTER DETAILS
          </DialogTitle >
          <div>
            <div><Container className="mb-2 mt-4">
              <Row>
                <Col><center><label style={{ fontFamily: 'Times New Roman'}}>Find Importer Name</label></center></Col>
                <Col>
                  <Form.Control size='sm' autoFocusstyle={{ fontFamily: 'Times New Roman'}}
                    variant="outlined" value={QuotImp_values.findimportername} onChange={QuotImp_findimporternamehandlechange}
                    onKeyDown={QuotImp_findimporternameKeyDown} />
                </Col>
              </Row>
              <Row className='mt-2'>
                <Col><center><label style={{ fontFamily: 'Times New Roman'}}>Find Importer Code</label></center></Col>
                <Col>
                  <Form.Control size='sm'style={{ fontFamily: 'Times New Roman'}}
                    label="Find Importer Code" variant="outlined" value={QuotImp_values.findimportercode} onChange={QuotImp_findimportercodehandlechange}
                    id='dialogImportIecCode' />
                </Col>
              </Row>
            </Container>
            </div>
          </div>
          <TableContainer style={{ height: '250px' }} >
            <Table stickyHeader className="table-bordered">
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell align='center' className="p-1" >Importer IEC Code</StyledTableCell>
                  <StyledTableCell align='center' className="p-1" >Importer Name</StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {DialogImporter.map((item) => (
                  <StyledTableRow hover key={item.importerIecNo} onClick={() => EditImporterDetails(item)}>
                    <StyledTableCell align='center' className="p-1">{item.importerIecNo}</StyledTableCell>
                    <StyledTableCell align='center' className="p-1">{item.importerName}</StyledTableCell>
                  </StyledTableRow>))}
              </TableBody>
            </Table>
          </TableContainer>
        </Dialog>

        <Dialog open={CustomHouseDetailshandleopen} onClose={CustomHouseDetailshandleClickClose} fullWidth={true} maxWidth='md' >
          <DialogTitle style={{ fontFamily: 'Times New Roman'}} align='center' className=" p-1 bg-info">
            VIEW CUSTOMHOUSE DETAILS
          </DialogTitle >
          <div>
            <div><Container className="mb-2 mt-4">
              <Row>
                <Col><center><label style={{ fontFamily: 'Times New Roman'}}>Find CusHouse Name</label></center></Col>
                <Col>
                  <Form.Control size='sm' style={{ fontFamily: 'Times New Roman'}}
                    variant="outlined" value={QuotImp_values.findCusHousename} onChange={QuotImp_findCusHousenamehandlechange} />
                </Col>
              </Row>
              <Row className='mt-2'>
                <Col><center><label style={{ fontFamily: 'Times New Roman'}}>Find CusHouse Code</label></center></Col>
                <Col>
                  <Form.Control size='sm' style={{ fontFamily: 'Times New Roman'}}
                    label="Find CusHouse Code" variant="outlined" value={QuotImp_values.findCusHousecode} onChange={QuotImp_findCusHousecodehandlechange} />
                </Col>
              </Row>
            </Container>
            </div>
          </div>
          <TableContainer style={{ height: '250px' }} >
            <Table stickyHeader className="table-bordered">
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell align='center' className="p-1" >CusHouse Code</StyledTableCell>
                  <StyledTableCell align='center' className="p-1" >CusHouse Name</StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {DialogCustomHouseCode.map((item) => (
                  <StyledTableRow hover key={item.clearanceLocationName} onClick={() => EditCustomHouseCode(item)}>
                    <StyledTableCell align='center' className="p-1">{item.clearanceLocationCode}</StyledTableCell>
                    <StyledTableCell align='center' className="p-1">{item.clearanceLocationName}</StyledTableCell>
                  </StyledTableRow>))}
              </TableBody>
            </Table>
          </TableContainer>
        </Dialog>

        <Dialog open={UnitCodeDetailshandleCopen} onClose={UnitCodeDetailshandleClickClose} fullWidth={true} maxWidth='md' >
          <DialogTitle align='center' style={{ fontFamily: 'Times New Roman'}} className=" p-1 bg-info">
            VIEW UNITCODE DETAILS
          </DialogTitle >
          <div>
            <div><Container className="mb-2 mt-4">
              <Row>
                <Col><center><label style={{ fontFamily: 'Times New Roman'}}>Find Unit Name</label></center></Col>
                <Col>
                  <Form.Control size='sm'style={{ fontFamily: 'Times New Roman'}}
                    variant="outlined" value={QuotImp_values.findUnitname} onChange={QuotImp_findUnitnamehandlechange} />
                </Col>
              </Row>
              <Row className='mt-2'>
                <Col><center><label style={{ fontFamily: 'Times New Roman'}}>Find Unit Code</label></center></Col>
                <Col>
                  <Form.Control size='sm'style={{ fontFamily: 'Times New Roman'}}
                    variant="outlined" value={QuotImp_values.findUnitcode} onChange={QuotImp_findUnitcodehandlechange} />
                </Col>
              </Row>
            </Container>
            </div>
          </div>
          <TableContainer style={{ height: '250px' }} >
            <Table stickyHeader className="table-bordered">
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell align='center' className="p-1" >Unit Code</StyledTableCell>
                  <StyledTableCell align='center' className="p-1" >Unit Rate</StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {DialogUOMSearch.map((item) => (
                  <StyledTableRow hover key={item.unitCode} onClick={() => EditUnitcodeaasign(item)}>
                    <StyledTableCell align='center' className="p-1">{item.unitCode}</StyledTableCell>
                    <StyledTableCell align='center' className="p-1">{item.unitName}</StyledTableCell>
                  </StyledTableRow>))}
              </TableBody>
            </Table>
          </TableContainer>
        </Dialog>
      </div>

      {/* ..........................................inputdesign............................................. */}
      <Home /><Snacbar open={open} message={message} severity={severity} onClose={handleClose} />
      <div style={{ paddingLeft: '100px' }}>
      <Row>
                    <Col xs={1}><ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small">
                        <ArrowBackIosIcon fontSize="small" style={{ fontSize: '16px', marginLeft: '5px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton></Col>
                    <Col xs={10}></Col>
                    <Col xs={1} style={{textAlign:'end'}}> <ToggleButton onClick={ForwordBotton} className='headerstyleEND' size="small">
                        <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton>
                    </Col>
                </Row>
        {/* <Grid2 container> */}
        <div >
          <Item style={{ height: '170px' }}>
            <Row>
              <Col xs={1}>
                {/* <ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small"> <ArrowBackIosIcon fontSize="small" style={{ fontSize: '16px', marginLeft: '5px' }} /> </ToggleButton> */}
              </Col>
              <Col xs={10}>
                <center style={{ color: 'red', fontWeight: 'bold', fontSize: '25px', marginTop: '0.3%',fontFamily: 'Times New Roman', }}>QUOTATION DETAILS-IMPORTER</center>
              </Col>
              <Col xs={1}>
                {/* <ToggleButton onClick={ForwordBotton} className='headerstyleEND' size="small">
                  <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px' }} /></ToggleButton> */}
              </Col>
            </Row>
            <Row className='mt-2 mb-1'>
              <Col xs={2}>
                <label style={{ fontFamily: 'Times New Roman'}}>Quotation Type</label>
                <Form.Select size='sm' required isInvalid={error.DrpQuatetionTyp}style={{ fontFamily: 'Times New Roman'}}
                  value={QuotImp_values.quotationtype} onChange={QuotImp_quotationtypehandlechange} id='DrpQuatetionTyp'>
                  <option value=""></option>
                  {DrpQuatetionTyp.map((item) => (
                    <option key={item.quotationType} value={item.quotationType}>{item.quotationType}</option>
                  ))}
                </Form.Select>
              </Col>
              <Col xs={3}>
                <label style={{ fontFamily: 'Times New Roman'}}>Service Type</label>
                <Form.Select size='sm' required isInvalid={error.servicetype}style={{ fontFamily: 'Times New Roman'}}
                  value={QuotImp_values.servicetype} onChange={QuotImp_servicetypehandlechange} id='serviceType'>
                  <option value="IMPORT">IMPORT</option>
                  <option value='EXPORT'>EXPORT</option>
                </Form.Select>
              </Col>
              <Col xs={3}>
                <label style={{ fontFamily: 'Times New Roman'}}>Item Description</label>
                <Form.Select size='sm'style={{ fontFamily: 'Times New Roman'}} value={QuotImp_values.itemdescription}
                  onChange={QuotImp_itemdescriptionhandlechange} id='itemDescribtion'>
                  <option value=""></option>
                  {tDrpItem.map((item) => (
                    <option key={item.serialNumber} value={item.itemName}>{item.itemName}</option>))}
                </Form.Select>
              </Col>
              <Col xs={4}>
                <label style={{ fontFamily: 'Times New Roman'}}>Customer Type</label>
                <Form.Select size='sm' style={{ fontFamily: 'Times New Roman'}} required isInvalid={error.customerType}
                  value={QuotImp_values.customertype} onChange={QuotImp_customertypehandlechange} id='customertype'>
                  {CustomerType.map((item) => (
                    <option key={item.serialNumber} value={item.customerType}>{item.customerType}</option>))}
                </Form.Select>
              </Col>
            </Row>
            <Row>
              <Col xs={2}>
                <label style={{ fontFamily: 'Times New Roman'}}>Based on Quotation</label>
                <Form.Select size='sm' required isInvalid={error.basedonQuotetion} style={{ fontFamily: 'Times New Roman'}}
                  value={QuotImp_values.basedonQuot} onChange={QuotImp_basedonQuothandlechange} id='BasedOnQuotation'>
                  <option value=""></option>
                  <option value='YES'>YES</option>
                  <option value='NO'>NO</option>
                </Form.Select>
              </Col>
              <Col xs={3}>
                <label style={{ fontFamily: 'Times New Roman'}}>Tariff Start Date</label>
                <Form.Control size='sm' type="date" required isInvalid={error.tariffStartDate} style={{ fontFamily: 'Times New Roman'}}
                  value={QuotImp_values.tarifstart_date} onChange={QuotImp_tarifstart_datehandlechange} id='tariffStartDate' />
              </Col>
              <Col xs={3}>
                <label style={{ fontFamily: 'Times New Roman'}}>Tariff End Date</label>
                <Form.Control size='sm' type="date" value={QuotImp_values.tarifend_date}style={{ fontFamily: 'Times New Roman'}}
                  onChange={QuotImp_tarifend_datehandlechange} required isInvalid={error.tarifend_date} id='TariffEndDate' />
              </Col>
              <Col xs={4}>
                <label style={{ fontFamily: 'Times New Roman'}}>Transist Mode</label>
                <Form.Control disabled size='sm' value={QuotImp_values.disable_transistmode} style={{ fontFamily: 'Times New Roman'}} isInvalid={error.transitTypeCode}
                  onChange={QuotImp_disable_transistmodehandlechange} id='transitmode' />
              </Col>
            </Row>
          </Item>
          <Item style={{ height: '210px' }}>
            <Row className='mb-1'>
              <Col xs={8} >
                <label style={{ fontFamily: 'Times New Roman'}}>Importer Name</label>
                <InputGroup className="mb-1" size='sm'>
                  <Form.Select required isInvalid={error.importerName}style={{ fontFamily: 'Times New Roman'}}
                    value={QuotImp_values.importername} onChange={QuotImp_importernamehandlechange} id='ImporterName'>
                    <option value=" "></option>
                    {CustomerBasedCustomerType.map((item) => (
                      <option key={item.serialNumber} value={item.importer_name}>{item.importer_name}</option>))}
                  </Form.Select>&nbsp;
                  <Button style={{ fontFamily: 'Times New Roman'}} size='small' variant="contained" color="primary"><SearchIcon fontSize="small"
                    onClick={ImporterDetailshandleClickopen} /></Button>
                </InputGroup>
              </Col>
              <Col xs={4}>
                <label style={{ fontFamily: 'Times New Roman'}}>Importer IEC Code</label>
                <Form.Control style={{ fontFamily: 'Times New Roman'}} disabled id='ImportIECcode' size='sm' value={QuotImp_values.disable_importerIecCode} />
              </Col>
            </Row>
            <Row>
              <Col className='mb-1'>
                <label style={{ fontFamily: 'Times New Roman'}}>EDI Location</label>
                <InputGroup>
                  <Form.Select size='sm' required isInvalid={error.ediLocation}style={{ fontFamily: 'Times New Roman'}}
                    value={QuotImp_values.edilocation} onChange={QuotImp_edilocationhandlechange} id='EdiLocation'>
                    <option value=""></option>
                    {CustomLocation.map((item) => (
                      <option key={item.clearanceLocationName} value={item.clearanceLocationName}>{item.clearanceLocationName}</option>))}
                  </Form.Select>&nbsp;
                  <Form.Control disabled size='sm' style={{ width: '31%', marginRight: '1%',fontFamily: 'Times New Roman' }}
                    value={QuotImp_values.disable_edilocation} />
                  <Button onClick={CustomHouseDetailshandleClickopen} size='small' variant="contained" color="primary"><SearchIcon fontSize="small" /></Button>
                </InputGroup>
              </Col>

              <Col className='mb-1'>
                <label style={{ fontFamily: 'Times New Roman'}}>Unit</label>
                <InputGroup>
                  <Form.Select size='sm' required isInvalid={error.unit}style={{ fontFamily: 'Times New Roman'}}
                    value={QuotImp_values.unit} onChange={QuotImp_unithandlechange} id='Unit'>
                    <option value=""></option>
                    {UOM.map((item) => (
                      <option key={item.unitCode} value={item.unitName}>{item.unitName}</option>))}
                  </Form.Select>&nbsp;
                  <Form.Control  disabled size='sm' style={{fontFamily: 'Times New Roman', width: '31%', marginRight: '1%' }} value={QuotImp_values.disable_unit} />
                  <Button onClick={UnitCodeDetailshandleClickopen} size='small' variant="contained" color="primary"><SearchIcon fontSize="small" /></Button>
                </InputGroup>
              </Col>

              <Col>
                <label style={{ fontFamily: 'Times New Roman'}}>Maximum Charge(INR)</label>
                <Form.Control size='sm' id='maximumChargeInr'style={{ fontFamily: 'Times New Roman'}}
                  type='number' variant="outlined" value={QuotImp_values.maxCharge} onChange={QuotImp_maxChargehandlechange} />
              </Col>
            </Row>
            <Row>
              <Col>
                <label style={{ fontFamily: 'Times New Roman'}}>Charge Name</label>
                <Form.Select size='sm' required isInvalid={error.ChargeName}style={{ fontFamily: 'Times New Roman'}}
                  value={QuotImp_values.chargename} onChange={QuotImp_chargenamehandlechange} id='chargename'>
                  <option value=""></option>
                  {Charge.map((item) => (
                    <option key={item.chargeName} value={item.chargeName}>{item.chargeName}</option>))}
                </Form.Select>
              </Col>
              <Col>
                <label style={{ fontFamily: 'Times New Roman'}}>Minimum Charge(INR)</label>
                <Form.Control size='sm' id='minimumChargeINR'style={{ fontFamily: 'Times New Roman'}}
                  type='number' variant="outlined" value={QuotImp_values.minCharge} onChange={QuotImp_minChargehandlechange} />
              </Col>
              <Col>
                <label style={{ fontFamily: 'Times New Roman'}}>Accessable Value Based Charge(%)</label>
                <Form.Control size='sm' type='number' id='AccessableValue'style={{ fontFamily: 'Times New Roman'}}
                  variant="outlined" value={QuotImp_values.AssessableValueBasedChrg} onChange={QuotImp_AssessableValueBasedChrghandlechange} />
              </Col>
            </Row>
            <center className='mt-1 mb-1 form-inline'>
              <Button style={{ fontFamily: 'Times New Roman'}}size='small' variant="contained" className='mt-1' color="success" disabled={savedsa} onClick={QuatetionSave}>{QutetionSve ? 'processing..' : 'Save'}</Button>{' '}
              <Button style={{ fontFamily: 'Times New Roman'}}size='small' variant="contained" className='mt-1' color="primary" disabled={Updatedsa} onClick={QuatetionUpdate}>{QutetionUpd ? 'processing..' : 'Update'}</Button>{' '}
              <Button style={{ fontFamily: 'Times New Roman'}}size='small' variant="contained" className='mt-1' color="error" disabled={Deletedsa} onClick={QuotationDelete}>{QutetionDlt ? 'processing..' : 'Delete'}</Button>{' '}
              <Button style={{ fontFamily: 'Times New Roman'}}size='small' variant="contained" className='mt-1' color="warning" onClick={refresh}>REFRESH</Button>{' '}
              <Button style={{ fontFamily: 'Times New Roman'}}size='small' variant="contained" className='mt-1' color="secondary" disabled={searchdsa} onClick={getTariffSearch}>{QutetionSearch ? 'processing..' : 'Search'}</Button>{' '}
              <Button style={{ fontFamily: 'Times New Roman'}}size='small' variant="contained" className='mt-1' color="success" disabled={Verifydsa} onClick={verified}>{QutetionVerify ? 'processing..' : 'Verify'}</Button>{' '}
              <Button style={{ fontFamily: 'Times New Roman'}}size='small' variant="contained" className='mt-1' color="error" disabled={UnVerifydsa} onClick={UnVerified}>{QutetionUnVerify ? 'processing..' : 'UN-Verify'}</Button>{' '}
            </center>
          </Item>
          <Item>
            <TableContainer sx={{ maxHeight: 240 }} className='scrollbarPrime'>
              <Table stickyHeader className='table table-bordered '>
                <TableHead>
                  <StyledTableRow>
                    <StyledTableCell style={{ textAlign: 'center', fontSize: '13px' }}>Sl</StyledTableCell>
                    <StyledTableCell style={{ textAlign: 'center', fontSize: '13px' }}>Importer_Name {importerNameSrch()}</StyledTableCell>
                    <StyledTableCell style={{ textAlign: 'center', fontSize: '13px' }}>mode {modeSrch()}</StyledTableCell>
                    <StyledTableCell style={{ textAlign: 'center', fontSize: '13px' }}>GateWayPort {gatewayportSrch()}</StyledTableCell>
                    <StyledTableCell style={{ textAlign: 'center', fontSize: '13px' }}>ChargeName {chargeNameSrch()}</StyledTableCell>
                    <StyledTableCell style={{ textAlign: 'center', fontSize: '13px' }}>UOM</StyledTableCell>
                    <StyledTableCell style={{ textAlign: 'center', fontSize: '13px' }}>Min_Charge</StyledTableCell>
                    <StyledTableCell style={{ textAlign: 'center', fontSize: '13px' }}>Max_Charge</StyledTableCell>
                    <StyledTableCell style={{ textAlign: 'center', fontSize: '13px' }}>Accessable_Value</StyledTableCell>
                    <StyledTableCell style={{ textAlign: 'center', fontSize: '13px' }}>Verified_Type</StyledTableCell>
                    <StyledTableCell style={{ textAlign: 'center', fontSize: '13px' }}>Item_Type</StyledTableCell>
                    <StyledTableCell style={{ textAlign: 'center', fontSize: '13px' }}>Quotation</StyledTableCell>
                    <StyledTableCell style={{ textAlign: 'center', fontSize: '13px' }}>Cus_Type</StyledTableCell>
                    <StyledTableCell style={{ textAlign: 'center', fontSize: '13px' }}>IEC_Code</StyledTableCell>
                    <StyledTableCell style={{ textAlign: 'center', fontSize: '13px' }}>Start_Date</StyledTableCell>
                    <StyledTableCell style={{ textAlign: 'center', fontSize: '13px' }}>End_Date</StyledTableCell>
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  {filterdetails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((item, index) => (
                      <StyledTableRow hover key={item.serialNumber} onClick={() => EditQuatetionImpDetails(item)}>
                        <StyledTableCell style={{ textAlign: 'center', fontSize: '10px', fontWeight: 'bold' }}>{item.serialNumber}</StyledTableCell>
                        <StyledTableCell style={{ textAlign: 'center', fontSize: '10px', fontWeight: 'bold' }}>{item.importerName}</StyledTableCell>
                        <StyledTableCell style={{ textAlign: 'center', fontSize: '10px', fontWeight: 'bold' }}>{item.transitTypeName}</StyledTableCell>
                        <StyledTableCell style={{ textAlign: 'center', fontSize: '10px', fontWeight: 'bold' }}>{item.gatewayPortName}</StyledTableCell>
                        <StyledTableCell style={{ textAlign: 'center', fontSize: '10px', fontWeight: 'bold' }}>{item.chargeName}</StyledTableCell>
                        <StyledTableCell style={{ textAlign: 'center', fontSize: '10px', fontWeight: 'bold' }}>{item.unitCode}</StyledTableCell>
                        <StyledTableCell style={{ textAlign: 'center', fontSize: '10px', fontWeight: 'bold' }}>{item.minimumCharge}</StyledTableCell>
                        <StyledTableCell style={{ textAlign: 'center', fontSize: '10px', fontWeight: 'bold' }}>{item.amtPerUnit}</StyledTableCell>
                        <StyledTableCell style={{ textAlign: 'center', fontSize: '10px', fontWeight: 'bold' }}>{item.maximumUnit}</StyledTableCell>
                        <StyledTableCell style={{ textAlign: 'center', fontSize: '10px', fontWeight: 'bold' }}>{item.verifiedStatus}</StyledTableCell>
                        <StyledTableCell style={{ textAlign: 'center', fontSize: '10px', fontWeight: 'bold' }}>{item.itemTypeName}</StyledTableCell>
                        <StyledTableCell style={{ textAlign: 'center', fontSize: '10px', fontWeight: 'bold' }}>{item.quotationType}</StyledTableCell>
                        <StyledTableCell style={{ textAlign: 'center', fontSize: '10px', fontWeight: 'bold' }}>{item.customerType}</StyledTableCell>
                        <StyledTableCell style={{ textAlign: 'center', fontSize: '10px', fontWeight: 'bold' }}>{item.iecNo}</StyledTableCell>
                        <StyledTableCell style={{ textAlign: 'center', fontSize: '10px', fontWeight: 'bold' }}>{item.tariffStartDate}</StyledTableCell>
                        <StyledTableCell style={{ textAlign: 'center', fontSize: '10px', fontWeight: 'bold' }}>{item.tariffEndDate}</StyledTableCell>
                      </StyledTableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              showFirstButton
              showLastButton
              component='div'
              count={filterdetails.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onChangeRowsPerpage={handleChangeRowsPerPage}
            />
          </Item>
        </div>
        {/* </Grid2> */}
      </div>
    </div >
  )
}

export default QuotationImporter